import { ThunkDispatch } from 'redux-thunk';
import { IWebSocketParameters } from '@missionlabs/smartagent-lib-shared';

import RootState from 'store/state';
import WSCompanionClient from 'services/Companion/Websocket';
import { acceptCall, rejectCall, endConnection, CallAction, hold, resume, mute, unmute } from  'store/call/call.actions';

import WebSocketCompanionTypes, { WebSocketCompanionActions } from './websocketCompanion.types';

export type WebSocketCompanionAction = { type: typeof WebSocketCompanionTypes.CREATE_WEBSOCKET_COMPANION_CONNECTION; payload: WSCompanionClient };

export function createWebSocketCompanionConnection(webSocketConfig: IWebSocketParameters) {
    return (dispatch: ThunkDispatch<RootState, undefined, CallAction | WebSocketCompanionAction>,) => {
        const socket = new WSCompanionClient(webSocketConfig);

        socket.addListener(WebSocketCompanionActions.ON_CALL_ANSWERED, () => {
            dispatch(acceptCall());
        });
        socket.addListener(WebSocketCompanionActions.ON_CALL_REJECTED, () => {
            dispatch(rejectCall());
        });
        socket.addListener(WebSocketCompanionActions.ON_CONNECTION_END, ({ detail }: { detail: { connectionId: string } }) => {
            dispatch(endConnection(detail.connectionId));
        });
        socket.addListener(WebSocketCompanionActions.ON_CALL_HOLD, ({ detail }: { detail: { connectionId: string } }) => {
            dispatch(hold(detail.connectionId));
        });
        socket.addListener(WebSocketCompanionActions.ON_CALL_RESUME, ({ detail }: { detail: { connectionId: string } }) => {
            dispatch(resume(detail.connectionId));
        });
        socket.addListener(WebSocketCompanionActions.ON_CALL_MUTE, () => {
            dispatch(mute());
        });
        socket.addListener(WebSocketCompanionActions.ON_CALL_UNMUTE, () => {
            dispatch(unmute());
        });
            
        dispatch({
            type: WebSocketCompanionTypes.CREATE_WEBSOCKET_COMPANION_CONNECTION,
            payload: socket,
        });
    };
}
